import React, { useState } from "react";

const DataTable = ({ columns, data, searchable = true, actions = true, onRowAction }) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;

  const filtered = data.filter((row) =>
    Object.values(row).some((val) => String(val).toLowerCase().includes(search.toLowerCase()))
  );

  const paginated = filtered.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const totalPages = Math.ceil(filtered.length / rowsPerPage);

  return (
    <div className="data-table-wrapper">
      <div className="data-table-toolbar">
        <div className="toolbar-title">
          <h3>Total: {filtered.length} records</h3>
        </div>
        {searchable && (
          <div className="data-table-search">
            <input
              type="text"
              placeholder="🔍 Search..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            />
          </div>
        )}
      </div>

      <div className="data-table-scroll">
        <table className="data-table">
          <thead>
            <tr>
              {columns.map((col, i) => (
                <th key={i}>{col.header}</th>
              ))}
              {actions && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {paginated.length === 0 ? (
              <tr>
                <td colSpan={columns.length + (actions ? 1 : 0)}>
                  <div className="empty-state">
                    <div className="empty-icon">📭</div>
                    <p>No records found</p>
                  </div>
                </td>
              </tr>
            ) : (
              paginated.map((row, rowIndex) => (
                <tr key={row.id || rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>
                      {col.render ? col.render(row) : row[col.key] || "-"}
                    </td>
                  ))}
                  {actions && (
                    <td>
                      <div className="table-actions">
                        <button className="btn-ghost-blue" onClick={() => onRowAction && onRowAction(row, "view")}>View</button>
                        <button className="btn-ghost-green" onClick={() => onRowAction && onRowAction(row, "edit")}>Edit</button>
                        <button className="btn-ghost-red" onClick={() => onRowAction && onRowAction(row, "delete")}>Delete</button>
                      </div>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="data-table-pagination">
        <p className="pagination-info">
          Showing {Math.min((page - 1) * rowsPerPage + 1, filtered.length)} to {Math.min(page * rowsPerPage, filtered.length)} of {filtered.length}
        </p>
        <div className="pagination-btns">
          {Array.from({ length: totalPages }, (_, i) => (
            <button key={i} className={page === i + 1 ? "active" : ""} onClick={() => setPage(i + 1)}>
              {i + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DataTable;